import { FormInstance } from 'antd';
import React from 'react';
import { FormConfigProps } from '../constants/constants';
import { CheckboxItem } from './CheckboxItem';
import { OtherInputItem } from './OtherInputItem';

type DynamicFormFieldProps = {
  formItemConfig: Record<string, FormConfigProps>;
  formPathParams: string[];
  form: FormInstance;
};

export const DynamicFormField = ({
  formItemConfig,
  formPathParams,
  form,
}: DynamicFormFieldProps) => {
  const formItemList = Object.values(formItemConfig);

  return formItemList.map((item) => {
    const statePathParams = [...formPathParams, item.value];

    return (
      <React.Fragment key={`${item.value}_input`}>
        {item.isInput ? (
          <OtherInputItem
            form={form}
            item={item}
            statePathParams={statePathParams}
          />
        ) : (
          <CheckboxItem
            key={`${item.value}_checkbox`}
            item={item}
            formPathParams={formPathParams}
            paddingLeft={item.paddingLeft}
            form={form}
          />
        )}
      </React.Fragment>
    );
  });
};
